import {
    IconArchive,
    IconBrandNotion,
    IconDotsVertical,
    IconEdit,
    IconFileImport,
    IconFilePlus
} from '@tabler/icons-react';

import { Button, Menu } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { DocumentDto, ProjectDto } from '../../api/models';
import { usePutApiProjectsArchiveId } from '../../api/projects/projects.ts';
import DocumentAddModal from '../Documents/DocumentAddModal.tsx';
import { useModal } from '../utils/useModal.tsx';
import ProjectEditModal from './ProjectEditModal.tsx';

interface ProjectDetailProps {
    project: ProjectDto;
    refetch: () => Promise<ProjectDto[]>;
    onDocumentCreated: (document: DocumentDto) => void;
    onProjectArchived: (project: ProjectDto) => void;
    menuColor?: string;
}

const ProjectMenu = ({
    project,
    refetch,
    onDocumentCreated,
    onProjectArchived,
    menuColor
}: ProjectDetailProps) => {
    const { mutateAsync: archiveProject } = usePutApiProjectsArchiveId();
    const { showArchiveConfirmModal } = useModal();
    const [addOpened, addModalActions] = useDisclosure();
    const [importOpened, importModalActions] = useDisclosure();
    const [editOpened, editModalActions] = useDisclosure();

    const archiveItem = () => {
        showArchiveConfirmModal(
            'Are you sure?',
            'This project will be archived, admin permissions are required to restore an archived project!',
            async () => {
                await archiveProject(project);
                onProjectArchived(project);
                await refetch();
            }
        );
    };

    return (
        <>
            {/*<DocumentImportModal*/}
            {/*    project={project}*/}
            {/*    opened={importOpened}*/}
            {/*    close={importModalActions.close}*/}
            {/*    refetch={refetch}*/}
            {/*    onDocumentCreated={onDocumentCreated}*/}
            {/*/>*/}
            <DocumentAddModal
                project={project}
                opened={importOpened}
                close={importModalActions.close}
                refetch={refetch}
                onDocumentCreated={onDocumentCreated}
                includeFileImport
            />
            <DocumentAddModal
                project={project}
                opened={addOpened}
                close={addModalActions.close}
                refetch={refetch}
                onDocumentCreated={onDocumentCreated}
            />
            <ProjectEditModal
                opened={editOpened}
                close={editModalActions.close}
                refetch={refetch}
                project={project}
            />

            <Menu shadow='md' width={200}>
                <Menu.Target>
                    <Button variant={'transparent'} color={menuColor}>
                        <IconDotsVertical />
                    </Button>
                </Menu.Target>
                <Menu.Dropdown>
                    <Menu.Item
                        onClick={importModalActions.open}
                        leftSection={<IconFileImport />}
                    >
                        Import Document
                    </Menu.Item>
                    <Menu.Item
                        onClick={addModalActions.open}
                        leftSection={<IconFilePlus />}
                    >
                        Add New Document
                    </Menu.Item>
                    <Menu.Divider />
                    <Menu.Item
                        onClick={() =>
                            window.open(
                                `https://www.notion.so/${project.id.replace(/-/g, '')}`,
                                '_blank'
                            )
                        }
                        leftSection={<IconBrandNotion />}
                    >
                        Open in Notion
                    </Menu.Item>
                    <Menu.Item
                        onClick={editModalActions.open}
                        leftSection={<IconEdit />}
                    >
                        Edit Project
                    </Menu.Item>
                    <Menu.Divider />
                    <Menu.Item
                        onClick={archiveItem}
                        color={'red'}
                        leftSection={<IconArchive />}
                    >
                        Archive Project
                    </Menu.Item>
                </Menu.Dropdown>
            </Menu>
        </>
    );
};

export default ProjectMenu;
